import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import UICustomizationDataService from "../../services/ui-customization-data-service/UICustomizationDataService";
import { UserAndRoleAdministrationUser } from "../../services/user-role-administration-service/Models";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseUICustomizationPresetUsersReturnType = Array<UserAndRoleAdministrationUser>;

export type UseUICustomizationPresetUsersParameters = {
    groupID: number;
    presetID: number;
} & BaseUseQueryParameters<UseUICustomizationPresetUsersReturnType>;

export function useUICustomizationPresetUsers({
    groupID,
    presetID,
    enabled,
    onError,
    onSuccess
}: UseUICustomizationPresetUsersParameters) {
    return useQuery<Array<UserAndRoleAdministrationUser>, RestError, UseUICustomizationPresetUsersReturnType>(
        keys.presetUserList(presetID),
        ({ signal }) => {
            return UICustomizationDataService.getUICustomizationPresetUsers(groupID, presetID, signal);
        },
        {
            enabled,
            onError,
            onSuccess
        }
    );
}